import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

import {
  FaHome,
  FaClipboardList,
  FaChartPie,
  FaUserCircle,
  FaTools,
  FaSignOutAlt,
  FaTimes
} from "react-icons/fa";

const MobileSidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const location = useLocation();
  const { user } = useAuth();

const navigation = [
  { name: 'الاحصائيات', href: '/admin-23nafs-33/dashboard', icon: <FaHome size={18} /> },
  { name: 'الاختبارات', href: '/admin-23nafs-33/dashboard/tests', icon: <FaClipboardList size={18} /> },
  { name: 'الفصول', href: '/admin-23nafs-33/dashboard/results', icon: <FaChartPie size={18} /> },
  { name: 'إدارة التعليقات', href: '/admin-23nafs-33/dashboard/profile', icon: <FaUserCircle size={18} /> },
  { name: 'الإعدادات & الاحصائيات', href: '/admin-23nafs-33/dashboard/settings', icon: <FaTools size={18} /> },
];


  if (!sidebarOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-40 lg:hidden"
        onClick={() => setSidebarOpen(false)}
      />

      <div
        dir="rtl"
        className="fixed inset-y-0 right-0 w-64 bg-white shadow-xl z-50 lg:hidden transform transition-all duration-300"
      >
        <div className="flex flex-col h-full">

          <div className="flex items-center justify-between h-16 px-4 border-b border-gray-200">
            <h1 className="text-xl font-bold text-blue-600">نافس</h1>

            <button
              onClick={() => setSidebarOpen(false)}
              className="p-2 text-gray-500 hover:text-red-600 transition-colors"
            >
              <FaTimes size={20} />
            </button>
          </div>

          {/* <div className="px-5 py-5 border-b border-gray-200">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center text-white text-lg font-semibold">
                {user?.name?.charAt(0) || 'U'}
              </div>

              <div className="text-right">
                <p className="text-sm font-semibold text-gray-900">{user?.name || "المستخدم"}</p>
                <p className="text-xs text-gray-500">طالب</p>
              </div>
            </div>
          </div> */}

          <nav className="flex-1 px-4 py-5 space-y-2">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href;

              return (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setSidebarOpen(false)}
                  className={`
                    flex items-center gap-4 px-4 py-3 rounded-lg text-sm font-medium transition-all
                    ${isActive
                      ? "bg-blue-50 text-blue-700 border-l-4 border-blue-600"
                      : "text-gray-700 hover:bg-gray-100"
                    }
                  `}
                >
                  <span className={`${isActive ? "text-blue-700" : "text-gray-500"}`}>
                    {item.icon}
                  </span>
                  <span className="text-base">{item.name}</span>
                </Link>
              );
            })}
          </nav>

          <div className="px-4 py-5 border-t border-gray-200">
            <button
              className="flex items-center gap-4 w-full px-4 py-3 text-sm font-medium text-gray-700 rounded-lg hover:bg-red-50 hover:text-red-600 transition-all"
            >
              <FaSignOutAlt size={18} />
              <span>تسجيل الخروج</span>
            </button>
          </div>

        </div>
      </div>
    </>
  );
};

export default MobileSidebar;
